import React, { useState, useRef, useEffect, useCallback } from "react";
import { useReactToPrint } from 'react-to-print';
import LoiNhuanBanHangApi from "service/QuanLyMuaBan/LoiNhuanBanHangApi";
import InDsLoiNhuanBanHang from './InDsLoiNhuanBanHang';
import { formatDayMonth } from "utils/formatDate";
import { pushNotification } from "utils/notifications";

export const BtnInDanhSach = ({ dataSearch, style }) => {
    const componentToPrintRef = useRef();
    const [isFetching, setIsFetching] = useState(false);
    const [fullDataToPrint, setFullDataToPrint] = useState(null);
    const triggerPrint = useReactToPrint({
        content: () => componentToPrintRef.current,
        onAfterPrint: () => setFullDataToPrint(null),
    });

    useEffect(() => {
        if (fullDataToPrint) {
            triggerPrint();
        }
    }, [fullDataToPrint, triggerPrint]);

    const handleFetchAndPrint = () => {
        if (isFetching) return;
        setIsFetching(true);

        const params = {
            ...dataSearch,
            pageIndex: -1,
            pageSize: 0,
            DateFrom: dataSearch.DateFrom ? formatDayMonth(dataSearch.DateFrom) : "",
            DateTo: dataSearch.DateTo ? formatDayMonth(dataSearch.DateTo) : "",
            LoiNhuanSS: dataSearch.LoiNhuanSS || 0
        };

        LoiNhuanBanHangApi.getData(params)
            .then(res => {
                if (res.status === 200 && res.data && res.data.List.length > 0) {
                    setFullDataToPrint(res.data);
                } else {
                    pushNotification("Không có dữ liệu để in!", "info", "TOP_CENTER", 2000);
                }
            })
            .catch(error => {
                console.error("Lỗi khi tải dữ liệu in:", error);
                pushNotification("Lỗi khi tải dữ liệu in!", "error", "TOP_CENTER", 2000);
            })
            .finally(() => {
                setIsFetching(false);
            });
    };

    return (
        <>
            <a
                type="button"
                className="con-bgnew color-print1 ml-1"
                onClick={handleFetchAndPrint}
                title="In danh sách"
                style={{
                    height: "42px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    marginTop: "25px",
                    ...style
                }}
            >
                {isFetching ? (
                    <span className="spinner-border spinner-border-sm" style={{ color: "#00B69B" }}></span>
                ) : (
                    <img src="/app-assets/images/logo-print-v2.png" alt="In phiếu" />
                )}
            </a>
            {fullDataToPrint && (
                <div style={{ display: "none" }}>
                    <InDsLoiNhuanBanHang
                        ref={componentToPrintRef}
                        listData={fullDataToPrint.List}
                        totals={fullDataToPrint}
                        isPrint={true}
                    />
                </div>
            )}
        </>
    );
};